// small rectangles
pyzel.homepage = pyzel.homepage || {};

pyzel.homepage.small_rectangles = {

	init: //$(

		function(){		

			let html = '';

			$.ajax({

				url: endpoint+'/cms/zones/63/objects',
				method: 'get'

			}).done( r => {

				$.each( r, ( k, i ) => {

					console.log( k );

					// news rectangle should have as background the image of the last news
					// as per the designer instructions
					if( k == 2 ){

						// hardcode test - image sizes don´t match.
						//i.bannerimg = 'https://s3.amazonaws.com/images.shaperbuddy.com/18/cms/1595384168586c.jpg';

						// get all news, as there is no way to do pagination..
						$.ajax({

							url: endpoint+'/cms/zones/65/objects',
							method: 'get'

						}).done( x => {

							i.bannerimg = x[0].hpthumb;

							html = 

							`<div class="col-md-12 col-lg-4">

								<a href="${ i.hpurl || '#' }" class="image-highlight">

									<div class="image">

										<img src="${ i.bannerimg }" alt="${ i.hptitle }">

									</div>

									<div class="description">

										${ i.hptitle }

									</div>
									
								</a>

							</div>`;

							$('#small-rectangles').append( html );

						})

					}else{

						html = 

						`<div class="col-md-12 col-lg-4">

							<a href="${ i.hpurl || '#' }" class="image-highlight">

								<div class="image">

									<img src="${ i.bannerimg }" alt="${ i.hptitle }">

								</div>

								<div class="description">

									${ i.hptitle }

								</div>
								
							</a>

						</div>`;

						$('#small-rectangles').append( html );

					}					

				})			

			})			

		}

	//)

}	